import React, { useState } from 'react';
import Modal from '../../Modal/Modal';
import styles from './ContactUs.module.css';

const ContactUs = ({ phoneNumber }) => {
  const [isOpen, setIsOpen] = useState(false);
  const telHref = phoneNumber ? `tel:${phoneNumber.replace(/[^\d+]/g, '')}` : null;
  const smsHref = phoneNumber ? `sms:${phoneNumber.replace(/[^\d+]/g, '')}` : null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className={styles.TriggerButton}
      >
        Contact Us
      </button>
      <Modal isOpen={isOpen}>
        <div className={styles.Sheet}>
          <p className={styles.Title}>Contact Us</p>
          <p className={styles.Subtitle}>
            {phoneNumber ? phoneNumber : 'No phone number on file for your gym yet.'}
          </p>
          <div className={styles.Actions}>
            <a
              href={telHref || '#'}
              className={styles.ActionButton}
              onClick={(e) => {
                if (!telHref) e.preventDefault();
                setIsOpen(false);
              }}
              aria-disabled={!telHref}
            >
              Call
            </a>
            <a
              href={smsHref || '#'}
              className={styles.ActionButton}
              onClick={(e) => {
                if (!smsHref) e.preventDefault();
                setIsOpen(false);
              }}
              aria-disabled={!smsHref}
            >
              Text
            </a>
          </div>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className={styles.CancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ContactUs;
